<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/schedules/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Schedule</h1>
          <div class="row">
            <div class="col-xs-12">
              <inputbox id="name" label="Megnevezés" v-bind:errors="errors" name="name" v-model="form.name"></inputbox>
              <button style="margin-bottom: 20px" class="button" type="button" v-on:click="add"><i class="fa fa-plus"></i></button>
            </div>
            <div v-if="form.items.length > 0" class="col-xs-12">
              <div class="table-with-title">
                <h2>Elemek</h2>
                <table class="list schedule">
                  <tr>
                    <th></th>
                    <th>Kezdő időpont (00:00:00)</th>
                    <th>Záró időpont (00:00:00)</th>
                    <th style="text-align: center">Hétfő</th>
                    <th style="text-align: center">Kedd</th>
                    <th style="text-align: center">Szerda</th>
                    <th style="text-align: center">Csütörtök</th>
                    <th style="text-align: center">Péntek</th>
                    <th style="text-align: center">Szombat</th>
                    <th style="text-align: center">Vasárnap</th>
                    <th style="text-align: center">Dátum</th>
                    <th></th>
                  </tr>
                  <tr v-for="(item, i) in form.items">
                    <td style="text-align: center">
                      {{ i+1 }}
                    </td>
                    <td>
                      <inputbox regexp_filter="[0-9]{1,2}:[0-9]{1,2}:[0-9]{1,2}" v-bind:errors="errors" :id="'start_time_'+i" :name="'start_time_'+i" v-model="item.start_time"></inputbox>
                    </td>
                    <td>
                      <inputbox regexp_filter="[0-9]{1,2}:[0-9]{1,2}:[0-9]{1,2}" v-bind:errors="errors" :id="'end_time_'+i" :name="'end_time_'+i" v-model="item.end_time"></inputbox>
                    </td>
                    <td style="text-align: center">
                      <checkbox :id="'monday_'+i" :name="'monday_'+i" v-model="item.monday.selected"></checkbox>
                    </td>
                    <td style="text-align: center">
                      <checkbox :id="'tuesday_'+i" :name="'tuesday_'+i" v-model="item.tuesday.selected"></checkbox>
                    </td>
                    <td style="text-align: center">
                      <checkbox :id="'wednesday_'+i" :name="'wednesday_'+i" v-model="item.wednesday.selected"></checkbox>
                    </td>
                    <td style="text-align: center">
                      <checkbox :id="'thursday_'+i" :name="'thursday_'+i" v-model="item.thursday.selected"></checkbox>
                    </td>
                    <td style="text-align: center">
                      <checkbox :id="'friday_'+i" :name="'friday_'+i" v-model="item.friday.selected"></checkbox>
                    </td>
                    <td style="text-align: center">
                      <checkbox :id="'saturday_'+i" :name="'saturday_'+i" v-model="item.saturday.selected"></checkbox>
                    </td>
                    <td style="text-align: center">
                      <checkbox :id="'sunday_'+i" :name="'sunday_'+i" v-model="item.sunday.selected"></checkbox>
                    </td>
                    <td>
                    <comboboxV2 :change="(value) => {dateChange(i, value)}" :id="'dateid_'+i" :name="'dateid_'+i" v-model="item.date_interval_id" :options="date_intervals"></comboboxV2>
                    </td>
                    <td>
                      <a class="small-button" href="javascript:void(0)" v-on:click="del(i)"><i class="fa fa-trash-alt"></i></a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      form: {
        name: '',
        items: []
      },

      date_intervals: [{
        value: 0,
        label: '- válassz -'
      }],
      errors: [],
      is_save: false
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('schedule/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.scheduleID != undefined ? _this.$route.query.scheduleID : 0), {
        success: function(response) {
          _this.form = response.schedule;
          _this.getDateIntervals();
        }
      });
    });
  },

  methods: {
    dateChange: function(index, value) {
      var item = this.form.items[index];
      item.start_time = '00:00:00';
      item.end_time = '23:59:59';
      item.monday.selected = false;
      item.tuesday.selected = false;
      item.wednesday.selected = false;
      item.thursday.selected = false;
      item.friday.selected = false;
      item.saturday.selected = false;
      item.sunday.selected = false;
    },

    getDateIntervals: function() {
      var _this = this;

      _this.$root.ajax('date_intervals/' + _this.$root.user.apikey, {
        method: 'POST',
        success: function(response) {
          response.date_intervals.map(function(di) {
            _this.date_intervals.push({
              value: di.id,
              label: di.name
            });
          });
        }
      });
    },

    del: function(i) {
      this.form.items.splice(i, 1);
    },

    add: function() {
      this.form.items.push({
        start_time: '00:00:00',
        end_time: '23:59:59',
        monday: {
          value: 1,
          selected: false
        },
        tuesday: {
          value: 1,
          selected: false
        },
        wednesday: {
          value: 1,
          selected: false
        },
        thursday: {
          value: 1,
          selected: false
        },
        friday: {
          value: 1,
          selected: false
        },
        saturday: {
          value: 1,
          selected: false
        },
        sunday: {
          value: 1,
          selected: false
        },
      });
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('schedule/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              _this.$router.push({path: '/schedules'});
            }
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// schedule.vue?68845c5c